import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import '../SuccessModal/index.css';
import './index.css';

function CloseBtn({ onClick, className }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className={`result-modal-close-btn${className ? ` ${className}` : ''}`}
      aria-label={t('common.ariaClose')}
      onClick={onClick}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
          d="M1 1L13 13M13 1L1 13"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}

function ErrorModal({ open, onClose, title, desc1, desc2, fieldTitle, fieldContent, btnText }) {
  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onClose}
      closeIcon={<CloseBtn />}
      closable
      centered
      width={448}
      className="result-modal"
      styles={{
        container: {
          borderRadius: 32,
          padding: 32,
          overflow: 'hidden',
        },
      }}
    >
      <div className="result-modal-body">
        <div className="result-modal-icon-wrap result-modal-icon-wrap--error">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              d="M35.3333 20C35.3333 11.5316 28.4684 4.66667 20 4.66667C11.5316 4.66667 4.66667 11.5316 4.66667 20C4.66667 28.4684 11.5316 35.3333 20 35.3333C28.4684 35.3333 35.3333 28.4684 35.3333 20ZM38 20C38 29.9411 29.9411 38 20 38C10.0589 38 2 29.9411 2 20C2 10.0589 10.0589 2 20 2C29.9411 2 38 10.0589 38 20Z"
              fill="#E7000B"
            />
            <path
              d="M18 19.9999V13.3333C18 12.2287 18.8954 11.3333 20 11.3333C21.1046 11.3333 22 12.2287 22 13.3333V19.9999C22 21.1045 21.1046 21.9999 20 21.9999C18.8954 21.9999 18 21.1045 18 19.9999Z"
              fill="#E7000B"
            />
            <path
              d="M20.0156 24.6667C21.1202 24.6668 22.0156 25.5622 22.0156 26.6667C22.0156 27.7713 21.1202 28.6667 20.0156 28.6667H20C18.8954 28.6667 18 27.7713 18 26.6667C18 25.5622 18.8954 24.6667 20 24.6667H20.0156Z"
              fill="#E7000B"
            />
          </svg>
        </div>
        {title && <h3 className="result-modal-title">{title}</h3>}
        {desc1 && <p className="result-modal-desc">{desc1}</p>}
        {desc2 && <p className="result-modal-desc">{desc2}</p>}
        {fieldTitle && fieldContent && (
          <div className="result-modal-fields">
            <span className="result-modal-fields-label">{fieldTitle}</span>
            {fieldContent}
          </div>
        )}
        {btnText && (
          <button type="button" className="result-modal-btn" onClick={onClose}>
            {btnText}
          </button>
        )}
      </div>
    </Modal>
  );
}

export default ErrorModal;
